import News from './locales/news_en.json'

// Latest news article, so the "News" entry of the main navigation always
// points to the most recent item instead of a hard-coded article id.
const LATEST_NEWS_ID = [...News.news]
    .sort((a, b) => new Date(b.date) - new Date(a.date))[0].id

export default {
    'project'      : 'IACR' , 
    'project_label'  : 'International Association of Cancer Registries' , 
    'project_slug' : 'iacr' , 
    'project_url' : 'https://www.the-iacr.net' , 
    'margin'       : { top: 30, right: 200, bottom: 80, left: 100, top_page: 0, left_page: 0 , title_height : 70 } , 
    'api_root'     : ''  , // @to be removed
    'data_version' : '11' ,
    'app_version'  : 'v1' , 
    'data'      : {
        '01' : {'years_available' : [1943,2012], 'exclude_all_cancers_id' : [8,26,33,55,57,58], 'all_cancers_id' : 57 , 'label' : 'CI5 Vol.I' , value : 1 , 'date_release' : '1992' } ,
        '02' : {'years_available' : [1943,2012], 'exclude_all_cancers_id' : [8,26,33,55,57,58], 'all_cancers_id' : 57 , 'label' : 'CI5 Vol.II' , value : 2 , 'date_release' : '1995' } ,
        '03' : {'years_available' : [1943,2012], 'exclude_all_cancers_id' : [8,26,33,55,57,58], 'all_cancers_id' : 57 , 'label' : 'CI5 Vol.III' , value : 3 , 'date_release' : '1998' } ,
        '04' : {'years_available' : [1943,2012], 'exclude_all_cancers_id' : [8,26,33,55,57,58], 'all_cancers_id' : 57 , 'label' : 'CI5 Vol.IV' , value : 4 , 'date_release' : '2001' } ,
        '05' : {'years_available' : [1943,2012], 'exclude_all_cancers_id' : [9,10,16,29,36,59,61,62], 'all_cancers_id' : 61 , 'label' : 'CI5 Vol.V' , value : 5 , 'date_release' : '2004' } ,
        '06' : {'years_available' : [1943,2012], 'exclude_all_cancers_id' : [23,49,50], 'all_cancers_id' : 49 , 'label' : 'CI5 Vol.VI' , value : 6 , 'date_release' : '2007' } ,
        '07' : {'years_available' : [1943,2012], 'exclude_all_cancers_id' : [25,62,63], 'all_cancers_id' : 62 , 'label' : 'CI5 Vol.VII' , value : 7 , 'date_release' : '2010' } ,
        '08' : {'years_available' : [1943,2012], 'exclude_all_cancers_id' : [25,62,63], 'all_cancers_id' : 62 , 'label' : 'CI5 Vol.VIII' , value : 8 , 'date_release' : '2013' } ,
        '09' : {'years_available' : [1943,2012], 'exclude_all_cancers_id' : [25,62,63], 'all_cancers_id' : 62 , 'label' : 'CI5 Vol.IX' , value : 9 , 'date_release' : '2016' } ,
        '10' : {'years_available' : [1943,2012], 'exclude_all_cancers_id' : [25,62,63], 'all_cancers_id' : 62 , 'label' : 'CI5 Vol.X' , value : 10 ,  'date_release' : '2020' } , 
        '11' : {'years_available' : [1943,2020], 'exclude_all_cancers_id' : [25,62,63], 'all_cancers_id' : 62 , 'label' : 'CI5 Vol.XI' , value : 11, 'date_release' : '2022' } ,  
        '12' : {'years_available' : [1943,2020], 'exclude_all_cancers_id' : [25,62,63], 'all_cancers_id' : 62 , 'label' : 'CI5 Vol.XII' , value : 12, 'date_release' : '2024' } ,
        'plus' : {'years_available' : [1943,2017], 'exclude_all_cancers_id' : [63], 'all_cancers_id' : 63 , 'label' : 'CI5 Plus' , value : 0, 'date_release' : '2024' } ,
        'all' : {'years_available' : [1943,2017], 'exclude_all_cancers_id' : [62,63], 'all_cancers_id' : 62 , 'label' : 'CI5 Plus' , value : 0, 'date_release' : '2024' } 
    },
    'romans' : ['I','II','III','IV','V','VI','VII','VIII','IX','X','XI','XII'] ,
    'conf' : {
        '01' : {"cancers" : [57],"populations":[217000199]},
        '02' : {"cancers" : [57],"populations":[217000199]},
        '03' : {"cancers" : [57],"populations":[217000199]},
        '04' : {"cancers" : [57],"populations":[217000199]},
        '05' : {"cancers" : [61],"populations":[217000199]},
        '06' : {"cancers" : [49],"populations":[217000199]},
        '07' : {"cancers" : [62],"populations":[217000199]},
        '08' : {"cancers" : [62],"populations":[217000199]},
        '09' : {"cancers" : [62],"populations":[217000199]},
        '10' : {"cancers" : [62],"populations":[217000199]},
        '11' : {"cancers" : [62],"populations":[217000199]},
        '12' : {"cancers" : [62],"populations":[217000199]},
        'plus' : {"cancers" : [63],"populations":[217000199]},
        'all' : {"cancers" : [63],"populations":[217000199]}
    },
    'api_nordcan_root' : 'https://nordcan.iarc.fr/api/nordcan/v2/2024/' , 
    // dev v2 : 'http://gcodev.nanga.iarc.lan/api/nordcan/v2/2019/' ,
    // v2 prod : 'http://gco.iarc.fr/v2/api/nordcan/v2/2019/',  
    // v1 prod : 'http://gco.iarc.fr/api/nordcan/v1/2018/', 
    // v2 local mathieu : 'http://localhost/GlobocanRestAPI/nordcan/v2/2019/' , 
    // v1 nanga : 'http://gcodev.nanga.iarc.lan/api/nordcan/v1/2018/' , 
    // v1 local fred : http://www.gco.local:8080/api/nordcan/v1/2018/'
    'years_available' :[1943,2020],
    'languages' : ['en'] , 
    'check_availability' : true , 
    'display_no_data_message' : true , 
    'all_cancers_id'    : 62 ,//55 , 
    'exclude_all_cancers_id' : [62,63] ,//DXX, grouped, all   
    'all_populations'   : [11200000] , 
    'last_year' : 2012,
    'color_no_data'   : '#7d7d80',
    'color_outmap'   : '#f0f0f0',
    'colors_types' : ['#0355a1','#d91616'], 
    'colors_sexes' : ['#6755a3','#3383b8','#ad027d'], 
    'colors_ages' : ["#4e79a7","#f28e2c","#e15759","#76b7b2","#59a14f","#edc949","#af7aa1","#ff9da7","#9c755f","#bab0ab","#1b9e77","#d95f02","#7570b3","#e7298a","#66a61e","#e6ab02","#a6761d","#666666"] , 
    'ages_start'        : [0,5,10,15,20,25,30,35,40,45,50,55,60,65,70,75,80,85], 
    'ages_labels' : ['0-4','5-9','10-14','15-19','20-24','25-29','30-34','35-39','40-44','45-49','50-54','55-59','60-64','65-69','70-74','75-79','80-84','85+'], 
    'indicators' : [
        {'key' : 'total' , 'label' : 'Numbers' } ,
        {'key' : 'total_pop' , 'label' : 'Populations' } ,
        {'key' : 'crude_rate' , 'label' : 'Crude Rate' } ,
        {'key' : 'asr' , 'label' : 'ASR (World)' } ,
        {'key' : 'asr_e' , 'label' : 'ASR (European)' } ,
        {'key' : 'asr_n' , 'label' : 'ASR (Nordic)' } ,
        {'key' : 'cum_risk' , 'label' : 'Cumulative risk' }
    ] , 
    'filter_populations' : false , 
    //'predefined_population' : true ,
    'cum_risk_age_default': 14, 
    'isos' : {
        208 : { 'iso' : 'DNK' , 'scale' : 1250 , 'translate' :  [-120,1300] } , 
        234 : { 'iso' : 'FRO' , 'scale' : 3000 , 'translate' :  [300,3300] } ,  
        246 : { 'iso' : 'FIN' , 'scale' : 450 , 'translate' :  [-90,570] } ,  
        304 : { 'iso' : 'GRL' , 'scale' : 160 , 'translate' :  [120,260] } , 
        352 : { 'iso' : 'ISL' , 'scale' : 700 , 'translate' :  [205,850] } , 
        578 : { 'iso' : 'NOR' , 'scale' : 320 , 'translate' :  [-15,450] } , 
        752 : { 'iso' : 'SWE' , 'scale' : 450 , 'translate' :  [-40,550] }
    },
    'default_dl_svg' : false , 
    'key_title' : 'Age Standardized Rate per 100 000 (World)' , 
    'home_graphics' : [
        { 'id' : 'svg1' ,  'asset' : 'home/isotype.svg' , 'name' : 'Infographics', 'route' : 'en/dataviz/isotype' } , 
        { 'id' : 'svg2' ,  'asset' : 'home/bubbles.svg' , 'name' : 'Bubble chart', 'route' : 'en/dataviz/bubbles?sexes=0' } , 
        { 'id' : 'svg3' ,  'asset' : 'home/bars.svg' , 'name' : 'Bar chart', 'route' : 'en/dataviz/bars' } , 
        { 'id' : 'svg4' ,  'asset' : 'home/trends.svg' , 'name' : 'Trends', 'route' : 'en/dataviz/trends?types=0&sexes=2&mode=cancer&group_populations=0&multiple_populations=0&multiple_cancers=1&cancers=20_23&populations=910&apc=cat_ca20v1.5_ca23v-1.5' }
    ],
    'navigation' : [
        { label : 'Home' , path : '/iacr/en/' , route : 'home' , class : 'current' }, 
        { label : 'About IACR' , route : 'about_slug' , params : { slug : 'overview' , lang : 'en' } },
        { label : 'Registry Directory' , route : 'registry-directory' },
        { label : 'CI5 2.0' , route : 'ci5_dataviz' , params : { slug : 'about' , lang : 'en' } },
        { label : 'Tools & Standards' , route : 'standards_slug' , params : { slug : 'icd-o-4' , lang : 'en' } },
        { label : 'Annual meeting' , route : 'meeting_slug' , params : { id : '2026-iacr-tanzania' , lang : 'en' }  },
        { label : 'Fellowships/Prizes' , route : 'fellowships_prizes_slug' , params : { slug : 'april-fritz-memorial-prize' , lang : 'en' } },
        { label : 'News' , route : 'news_slug' , params : { id : LATEST_NEWS_ID , lang : 'en' } }
    ],
    "refs" : {
        "downloads" : true , 
        "tab" : true , 
        "references" : [
            { "title" : "Website citation" , "desc" : "Ferlay J, Ervik M, Lam F, Laversanne M, Colombet M, Mery L, Piñeros M, Znaor A, Soerjomataram I, Bray F (2024). Global Cancer Observatory: Cancer Today (version 1.1). Lyon, France: International Agency for Research on Cancer. Available from: https://gco.iarc.who.int/today, accessed [DD Month YYYY]." } ,
            { "title" : "Global Cancer Statistics: Overview" , "desc" : "Bray F, Laversanne M, Sung H, Ferlay J, Siegel RL, Soerjomataram I, Jemal A. Global cancer statistics 2022: GLOBOCAN estimates of incidence and mortality worldwide for 36 cancers in 185 countries. CA Cancer J Clin. 2024 May-Jun;74(3):229-263. doi: 10.3322/caac.21834. Epub 2024 Apr 4. PMID: 38572751." } , 
            { "title" : "Global Cancer Statistics: Sources and Methods" , "desc" : "Filho AM, Laversanne M, Ferlay J, Colombet M, Piñeros M, Znaor A, Parkin DM, Soerjomataram I, Bray F. The GLOBOCAN 2022 cancer estimates: Data sources, methods, and a snapshot of the cancer burden worldwide. Int J Cancer. 2024 Dec 17. doi: 10.1002/ijc.35278. Epub ahead of print. PMID: 39688499." } 
        ]
    },
    // 'dataviz_filters' : { hide_tab_look : true } , 
    'graphics' : [
        {
          name: "Explore data by volume",
          short_name: "Within a volume",
          grouping : "dataviz" , 
          is_home: true,
          route: "dataviz_bars", 
          params : { volume : 12 } ,
          hide: 0,
          home_image: "bar-horizontal.svg",
          items : [
                { key : 'bars', type : 'dataviz', name : 'Bar charts' , route : 'dataviz_bars' , image : 'bar-horizontal.svg' , params : { volume : 12 } },
                { key : 'age-specific', type : 'dataviz' , name : 'Age-specific rates' , route : 'dataviz_age_specific' , image : 'line_graph.svg' , params : { volume : 12 }},
                { key : 'tables', type : 'dataviz' , name : 'Tables' , route : 'dataviz_tables' , image : 'time_table.svg' , params : { volume : 12 }} ,
                { key : 'pyramid', type : 'dataviz' , name : 'Population pyramid' , route : 'dataviz_population_pyramid' , image : 'population_pyramid.svg' , params : { volume : 12 } },
                { key : 'dic', type : 'dataviz' , name : 'Dictionary' , route : 'dataviz_dictionary' , image : 'dic.svg' , params : { volume : 12 } }
            ], 
          active : true 
        },
        {
          "name": "Compare data across volumes",
          short_name: "Across volumes",
          "is_home": true,
          "grouping" : "dataviz_volume" , 
          "route": "dataviz_ranking",
          "hide": 0,
          "home_image": "ranking-2.svg",
          items : [
                { key : 'compare', type : 'dataviz'  , name : 'Compare bars', route : 'dataviz_compare' , image : 'bar-horizontal.svg' },
                { key : 'ranking', type : 'dataviz' , name : 'Cancer site ranking', route : 'dataviz_ranking' , image : 'ranking-2.svg' },
                { key : 'trend', type : 'dataviz' , name : 'Trend', route : 'dataviz_trends_volumes' , image : 'line_graph.svg' },
                { key : 'dic', type : 'dataviz' , name : 'Dictionary' , route : 'dataviz_dictionary' , image : 'dic.svg' , params : { force_volume : 'all' } }
            ], 
          active : true 
        },
        {
          name: "Explore data by year (CI5Plus)",
          short_name: "By Year",
          grouping : "dataviz_ci5plus" , 
          is_home: true,
          route: "dataviz_bars_ci5plus", 
          params : { volume : 12 } ,
          hide: 0,
          home_image: "bar-horizontal.svg",
          items : [
                { key : 'trends', type : 'dataviz', name : 'Trends' , route : 'dataviz_trends_ci5plus' , image : 'lines_chart.svg' , params : { volume : "plus" } },
                { key : 'bars', type : 'dataviz', name : 'Bars chart' , route : 'dataviz_bars_ci5plus' , image : 'bar-horizontal.svg' , params : { volume : "plus" } },
                { key : 'age-specific', type : 'dataviz' , name : 'Age-specific' , route : 'dataviz_age_specific_ci5plus' , image : 'line_graph.svg' , params : { volume : "plus" }},
                { key : 'tables', type : 'dataviz' , name : 'Tables' , route : 'dataviz_tables_ci5plus' , image : 'time_table.svg' , params : { volume : "plus" }} ,
                { key : 'pyramid', type : 'dataviz' , name : 'Population pyramid' , route : 'dataviz_population_pyramid_ci5plus' , image : 'population_pyramid.svg' , params : { volume : "plus" }},
                { key : 'dic', type : 'dataviz' , name : 'Dictionary' , route : 'dataviz_dictionary' , image : 'dic.svg' , params : { force_volume : "plus" } }

            ], 
          active : true 
        },
        {
          "name": "See metadata for each volume",
          short_name: "Meta data",
          "route": "dataviz_metadata",
          "params" : { num_volume : 12 } ,
          "grouping" : "dataviz" , 
          "home": false,
          "offset": "",
          "hide": 1,
          "home_image": "time_table.svg",
          items : [] , 
          active : false 
        }
    ],
    'continents' : [
        { 'id' : 1 ,'label' : 'Africa' , 'country' : 903 , 'nb_reg' : 123 , 'color' : 'purple' , 'text_color' : '#fff' ,  'sort' : 1 } ,  // old 
        { 'id' : 3 ,'label' : 'Northern America' , 'short_label' : 'North America', 'nb_reg' : 67, 'color' : '#20639B' , 'text_color' : '#fff' , 'country' : 905 , 'sort' : 5} , 
        { 'id' : 2 ,'label' : 'Latin America and the Caribbean' , 'nb_reg' : 54 , 'color' : '#3CAEA3' , 'short_label' : 'South America' , 'country' : 904 , 'sort' : 4} , 
        { 'id' : 4 ,'label' : 'Asia' , 'country' : 935 , 'nb_reg' : 176 , 'color' : '#f4a60b' , 'sort' : 2} ,
        { 'id' : 5 ,'label' : 'Europe' , 'country' : 908 , 'nb_reg' : 45 , 'color' : 'green',  'text_color' : '#fff' , 'sort' : 3} ,
        { 'id' : 6  ,'label' : 'Oceania' , 'country' : 909 , 'nb_reg' : 65 , 'color' : '#ef476f', 'sort' : 6 ,'text_color' : '#fff' }
    ],
    'areas' : [
        {"id":189,"area":10,"label":"Eastern Asia","continent":4,"centroid":"CHN" , 'color' : '#2EAD10', "text_color" : '#fff', 'nb_reg' : 118 },
        {"id":190,"area":1,"label":"Eastern Africa","continent":1,"centroid":"RWA", 'color' : '#e51919',"zoom":3.2, "text_color" : '#fff', 'nb_reg' : 26},
        {"id":191,"area":2,"label":"Middle Africa","continent":1,"centroid":"GNQ", 'color' : '#e51919',"zoom":3.1, "text_color" : '#fff', 'nb_reg' : 61},
        {"id":192,"area":3,"label":"Northern Africa","continent":1,"centroid":"LBY", 'color' : '#e51919', "text_color" : '#fff', 'nb_reg' : 21},
        {"id":193,"area":4,"label":"Southern Africa","continent":1,"centroid":"BWA", 'color' : '#e51919',"zoom":5.5, "text_color" : '#fff', 'nb_reg' : 81},
        {"id":194,"area":5,"label":"Western Africa","continent":1,"centroid":"MLI", 'color' : '#e51919',"zoom":4, "text_color" : '#fff', 'nb_reg' : 26},
        {"id":195,"area":6,"label":"Caribbean","continent":2,"centroid":"DOM","zoom":5.5 , 'color' : '#F6F31E', "text_color" : '#000', 'nb_reg' : 32},
        {"id":196,"area":7,"label":"Central America","continent":2,"centroid":"MEX" , 'color' : '#F6F31E', "text_color" : '#000', 'nb_reg' : 48},
        {"id":196,"area":7,"label":"North America","continent":2,"centroid":"USA" , 'color' : '#F6F31E', "text_color" : '#000', 'nb_reg' : 48},
        {"id":197,"area":11,"label":"South-Eastern Asia","continent":4,"centroid":"KHM","zoom":3.2, 'color' : '#2EAD10', "text_color" : '#fff', 'nb_reg' : 54},
        {"id":198,"area":12,"label":"South-Central Asia","continent":4,"centroid":"IRN","zoom":2.9, 'color' : '#2EAD10', "text_color" : '#fff', 'nb_reg' : 31},
        {"id":199,"area":13,"label":"Western Asia","continent":4,"centroid":"KWT","zoom":4.1, 'color' : '#2EAD10', "text_color" : '#fff', 'nb_reg' : 48},
        {"id":200,"area":14,"label":"Central and Eastern Europe","continent":5,"centroid":"UKR" , 'color' : '#196be5',"zoom":3.1, "text_color" : '#fff', 'nb_reg' : 31},
        {"id":201,"area":15,"label":"Northern Europe","continent":5,"centroid":"DNK","zoom":4.6 , 'color' : '#196be5', "text_color" : '#fff', 'nb_reg' : 22},
        {"id":202,"area":16,"label":"Southern Europe","continent":5,"centroid":"ITA","zoom":5 , 'color' : '#196be5', "text_color" : '#fff', 'nb_reg' : 34},
        {"id":203,"area":17,"label":"Western Europe","continent":5,"centroid":"FRA","zoom":7 , 'color' : '#196be5', "text_color" : '#fff', 'nb_reg' : 28},
        {"id":206,"area":8,"label":"South America","continent":2,"centroid":"BOL","zoom":2.1 , 'color' : '#F6F31E', "text_color" : '#000', 'nb_reg' : 35},
        {"id":206,"area":8,"label":"Oceania","continent":3,"centroid":"AUS","zoom":2.1 , 'color' : '#e51962', "text_color" : '#fff', 'nb_reg' : 25}
    ],
    'show_pyramid' : true , 
    'cancer_select_close_on_select' : true
  }